var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQMentis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 254 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.779 179.011C196.337 165.31 204 147.05 204 127C204 84.4741 169.526 50 127 50C84.4741 50 50 84.4741 50 127C50 169.526 84.4741 204 127 204C147.318 204 165.797 196.131 179.557 183.274L143.811 148.054C142.631 146.891 142.617 144.992 143.78 143.811C144.943 142.631 146.842 142.617 148.022 143.78L183.779 179.011ZM127.1 102.36C127.569 109.83 133.322 125.24 152.36 127.117C144.262 128.196 127.829 134.755 127.1 152.36C127.238 144.566 122.526 128.606 102.36 127.117C110.044 126.794 125.707 121.389 127.1 102.36ZM169.993 96.2768C160.855 95.3759 158.381 87.9791 158.155 84.3934C157.486 93.5274 149.682 96.1215 145.993 96.2768C155.673 96.9914 158.221 104.652 158.155 108.393C158.505 99.9429 166.106 96.7946 169.993 96.2768Z",
    fill: "#0096FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQMentis);
export default __webpack_public_path__ + "static/media/QMentis.dfa2df58ba4abd12d69d1066bf586a5d.svg";
export { ForwardRef as ReactComponent };